module.exports = __webpack_public_path__ + "assets/images/ant1_plus.c2a378b86b9cd3582333e398231acd1a.png";